/// <amd-module name="Checks/Approvals/Web/Constants" />
export const materializeApprovalIdentitiesFeatureFlag: string = "Pipelines.Policy.MaterializeApprovalIdentities";